import React from "react";
import { CheckoutSection, hiddenAnchorWithWrapStyle, OptionListItemRadio } from "../../components";
import { Fade } from "../../componentAnimations";

const CheckoutShipmentPresentation = (
    {
        shippingOptions,
        selectedId,
        canChange,
        onClickChange,
        isCollapsed,
        onSelected,
        isPendingRefresh
    }) => {
    
        const selectedOption = shippingOptions.find(opt => opt.id === selectedId);

        return (
            <CheckoutSection label='Shipping Method' hidden={false}>
                {isPendingRefresh
                    ? <span className="fa fa-spinner fa-spin" />
                    : (
                        <React.Fragment>
                            {!!selectedOption &&
                                <div style={{ lineHeight: 2 }}>
                                    <button
                                        className="btn btn-link"
                                        style={hiddenAnchorWithWrapStyle}
                                        onClick={(e) => onClickChange(e)}
                                    >
                                        {selectedOption.nameWithPrice}
                                        {canChange &&
                                            <span style={{ marginLeft: 20, color: '#004af4', fontWeight: 600 }}>
                                                {isCollapsed ? "Change" : "Done"}
                                            </span>}
                                        {!!selectedOption.estimatedDeliveryDate &&
                                            <React.Fragment>
                                                <div style={{ flexBasis: "100%", height: 0 }}></div>
                                                <div>
                                                    Estimated Delivery Date: {selectedOption.estimatedDeliveryDate}
                                                </div>
                                            </React.Fragment>
                                        }
                                    </button>
                                </div>}
                            {shippingOptions.length === 0 &&
                                <div>Sorry, but no shipping methods are available.</div>}

                            <Fade inProp={!isCollapsed}>
                                <div>{shippingOptions.map(({ id, nameWithPrice, estimatedDeliveryDate }) => (
                                    <OptionListItemRadio
                                        id={id}
                                        key={id}
                                        isSelected={(id === selectedId)}
                                        onClick={onSelected}
                                        label={nameWithPrice}
                                        labelLine2={(!!estimatedDeliveryDate) ? `Estimated Delivery Date: ${estimatedDeliveryDate}` : ""}
                                    />))}
                                </div>
                            </Fade>
                        </React.Fragment>
                    )}
            </CheckoutSection>
        );
    };

export default CheckoutShipmentPresentation
